import store from '../vuex'

export default () => {
  if (store.getters.showSidebar) {
    store.dispatch('toggleSidebar')
  }
}
